import { useSyncExternalStore } from 'react';

/** Lets the notifications card ask the Handover tab to open a specific handover
 *  (in the "Assigned to me" segment) when you click "View". */
let focusId: string | null = null;
const listeners = new Set<() => void>();

export function setHandoverFocus(id: string | null) {
  focusId = id;
  listeners.forEach((l) => l());
}
export function useHandoverFocus(): [string | null, (id: string | null) => void] {
  const id = useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
    () => focusId,
    () => focusId,
  );
  return [id, setHandoverFocus];
}
